import { useFetch } from '@cordata/buffet';

import { ruby } from '~/utils/core/factories';

const serializeOne = v => ({
  data: {
    careTeam: v.careTeam || false,
    isPcp: v.isPcp || false,
    isPrimary: v.isPrimary || false,
    provider: {
      providerUid: v.provider.id,
    },
    patient: {
      patientUid: v.patient.id,
    },
    preferredLocation: {
      preferredLocationUid: v.preferredLocation?.id,
    },
    type: 'provider-patients',
  },
});

const fetchOne = (id, options = {}) =>
  // surprised this works since it fails lint
  /* eslint-disable-next-line react-hooks/rules-of-hooks */
  useFetch(`/provider-patients/${id}`, options);

const fetchAll = (options = {}) =>
  // surprised this works since it fails lint
  /* eslint-disable-next-line react-hooks/rules-of-hooks */
  (options.patient ? useFetch(`/patients/${options.patient.id || options.patient}/provider-patients`) : useFetch('/provider-patients'));

const store = {
  fetchAll,
  fetchOne,

  ...ruby('/provider-patients', { serializeOne }),
};

export { store };
